import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27a01348"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "login-with-google-btn"
}, " Sign in with Google ", -1))

import type { CallbackTypes } from "vue3-google-login";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleAuthComponent',
  setup(__props) {

const store = useStore();
const router = useRouter();

const callback: CallbackTypes.TokenResponseCallback = async (response) => {
  await store.dispatch("POST_GOOGLE_LOGIN", {
    access_token: response.access_token
  });

  await router.push({ name: 'admin' });
};

return (_ctx: any,_cache: any) => {
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!

  return (_openBlock(), _createBlock(_component_GoogleLogin, {
    callback: callback,
    "popup-type": "TOKEN"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})